import { render, staticRenderFns } from "./VAdministrationHistory.vue?vue&type=template&id=7d15e8ac&"
import script from "./VAdministrationHistory.vue?vue&type=script&lang=ts&"
export * from "./VAdministrationHistory.vue?vue&type=script&lang=ts&"
import style0 from "./VAdministrationHistory.vue?vue&type=style&index=0&id=7d15e8ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports